import { BOOKING_APPLICATION_QUESTION_MODEL } from "@/models/booking-application-question-model";
import pluralize from "pluralize";

export const BOOKING_APPLICATION_QUESTIONS_ANSWER_MODEL =
  "booking-application-question-answer";

const applicationAnswerModel = {
  answers: [],
  attachments: [],
  canContinue: false,
  question: {
    type: pluralize(BOOKING_APPLICATION_QUESTION_MODEL),
    jsonApi: "hasOne"
  },
  application: {
    type: "applications",
    jsonApi: "hasOne"
  }
};

export default applicationAnswerModel;
